import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ClienteEntity } from "@catalogo/models";
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class OperacionalDevOpsDataService
{
    protected url: string;

    constructor(
        @Inject(OPERACAO_API_URL) private urlBase: string,
        private httpClient: HttpClient
    )
    {
        this.url = `${this.urlBase}/v1/DevOps`;
    }

    public aplicarMigrations = (cliente: ClienteEntity) =>
        this.httpClient.post(`${this.url}/AplicarMigrations`, {
            nomeFantasia: cliente.nomeFantasia,
            razaoSocial: cliente.razaoSocial,
            cnpjCpf: cliente.cnpj,
            emailAdministrador: cliente.emailAdministrador,
            nomeAdministrador: cliente.nomeAdministrador || cliente.nomeFantasia,
            schema: cliente.dataBaseSchema
        });
}
